import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import { formatDuration } from "date-fns";
import { Showalert } from "../../../../../customComponents/CustomSweetAlert/SweetAlert";
import editIcon from "./../../../../../../Assets/icons/Un-Checkbox.svg";
import CustomTable from "../../../../../customComponents/CustomTable";

const EditDiscount = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subproductOptions, setSubproductOptions] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [fuelOptions, setFuelOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [variantdd, setVariantDD] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [discountTypeData, setDiscountTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  const location = useLocation();
  const { data } = location.state || {};

  const [discountData, setDiscountData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [discountIdValue, setDiscountIdValue] = useState();
  const [discountSpecificId, setSpecificDiscountId] = useState();

  const [wholeDiscountIdValue, setWholeDiscountIdValue] = useState();

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
        // make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchDiscountType();
  }, []);

  const fetchDiscountType = async () => {
    try {
      const payload = {
        orderBy: "discount_type_id desc",
        pageSize: 10,
        page: 0,
      };

      const response = await axiosInstance.post("/discounttype/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((data) => ({
        label: data.discount_type_name,
        value: data.discount_type_value,
      }));

      setDiscountTypeData(options);
    } catch (error) {
      console.error("Error fetching color options:", error);
    }
  };

  const DiscountInputs = [
    {
      name: "min_quantity",
      label: "Minimum Quantity",
      type: "number",
      placeholder: "Enter Min Quantity",
      // options: warrantyOptions,
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[1-9][0-9]*$/,
        message: "Please enter a positive number with no leading zeros",
      },
    },
    {
      name: "max_quantity",
      label: "Maximum Quantity",
      type: "number",
      placeholder: "Enter Max Quantity",
      // options: warrantyOptions,
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[1-9][0-9]*$/,
        message: "Please enter a positive number with no leading zeros",
      },
    },
    {
      name: "discount",
      label: "(₹) Discount",
      type: "number",
      // options: warrantyOptions,
      placeholder: "Enter Discount (rupees)",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[1-9][0-9]*$/,
        message: "Please enter a positive number with no leading zeros",
      },
    },
  ];

  const VariantInputs = [
    // {
    //   name: "productName",
    //   label: "Product Name",
    //   type: "dropdown",
    //   options: productOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "variant_id",
    //   label: "Variant Name",
    //   type: "dropdown",
    //   options: variantdd,
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "subproductName",
    //   label: "Subproduct Name",
    //   placeholder: "Subproduct Name",
    //   type: "text",
    //   //options: subproductOptions,
    //   disabled: true,
    //   //required: true,
    //   gridClass: "col-lg-4",
    //   //validation: { required: true },
    // },
    // {
    //   name: "make",
    //   label: "Make Name",
    //   placeholder: "Make Name",
    //   type: "text",
    //   // options: makeOptions,
    //   disabled: true,
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    // },
    {
      name: "discount_name",
      label: "Discount Name",
      type: "text",
      placeholder: "Enter Discount Name",
      // disabled: true,
      //options: fuelOptions,
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true
    },
    {
      name: "model_id",
      label: "Model",
      placeholder: "Model",
      type: "multiselectdropdown",
      // disabled: true,
      options: modelOptions,
      required: true,
      gridClass: "col-lg-4",
    },

    // {
    //   name: "vehiclecolor",
    //   label: "Vehicle Color",
    //   type: "text",
    //   placeholder: "Vehicle Color",
    //   disabled: true,
    //   // options: colorOptions,
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    // },
    // {
    //   name: "exshowroomprice",
    //   label: "EX-Showroom Price",
    //   type: "text",
    //   placeholder: "EX-Showroom Price",
    //   // required: true,
    //   disabled: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    // },
    {
      name: "duration_months",
      label: "Duration (Months)",
      type: "number",
      // options: warrantyOptions,
      placeholder: "Enter the duration",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^(?:[1-9]|[1-9][0-9]|[1-5][0-9]{2}|600)$/,
        message:
          "Duration should be a positive number, less than or equal to 600 with no leading zeros",
      },
    },

    // discount_fromdate:formData.discount_fromdate,
    // discount_todate:formData.discount_todate,
    // {
    //   name: "discount_fromdate",
    //   label: "Discount From Date",
    //   type: "date",
    //   // options: warrantyOptions,
    //   maxDate: new Date(),
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "discount_todate",
    //   label: "Discount To Date",
    //   type: "date",
    //   // minDate: formData?.discount_fromdate
    //   //   ? formData?.discount_fromdate
    //   //   : new Date(),
    //   minDate: new Date(),
    //   // options: warrantyOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },

    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  const VARIANT_TABLE_HEADERS = [
    // "Sr No.",
    // "Discount Id",
    "Min Qty",
    "Max Qty",
    "Discount Amount",
    // "Min Quantity",
    // "Status",
    "Action",
  ];

  const variantKeyMapping = {
    "Sr No.": "Sr No.",
    "Min Qty": "min_quantity",
    "Max Qty": "max_quantity",
    "Discount Amount": "amount",
    "Discount Fromdate": "discount_fromdate",
    "Discount Todate": "discount_todate",
    Discount: "discount",
    Status: "status",
    Action: [{ type: "edit", icon: editIcon, label: "Edit" }],
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // fetchDiscountList(newPage);
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    setSpecificDiscountId(rowData.id);
    getDetailsEdit(rowData.id);
    setIsEdit(true);
    // navigate(`${ROUTES_NAVIGATION.EDITDISCOUNTLIST}`, { state: { data: rowData } });
  };

  const getDetailsEdit = async (id) => {
    console.log(id, "getDetailsId");
    try {
      // setLoading(true)
      const response = await axiosInstance.get(`/subdiscount/edit/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response.data?.data;
      console.log(fetchedData, "getEditData");

      setFormData((prevData) => ({
        ...prevData,
        discount: fetchedData?.amount,
        max_quantity: fetchedData?.max_quantity,
        min_quantity: fetchedData?.min_quantity,
      }));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      // setLoading(false)
    }
  };

  const handleFormSave = async (formData) => {
    const errors = {};
    let isValid = true;

    DiscountInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (
      formData.min_quantity &&
      formData.max_quantity &&
      Number(formData.max_quantity) < Number(formData.min_quantity)
    ) {
      errors.min_quantity =
        "Minimum Qty cannot be greater than Maximum Quantity";
      isValid = false;
    }

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    try {
      const payload = {
        min_quantity: formData.min_quantity,
        max_quantity: formData.max_quantity,
        amount: formData.discount,
        discount_id: wholeDiscountIdValue,
        // status: 1
      };

      // const url = isEdit
      //   ?
      //   ``
      //   // `/podraftdetails/update/${draftId}`
      //   : "/subdiscount/create";

      const url = isEdit
        ? `/subdiscount/update/${discountSpecificId}`
        : "/subdiscount/create";

      const method = isEdit ? "patch" : "post";

      const response = await axiosInstance({
        method, // Dynamically set the HTTP method
        url,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        setFormData({});
        fetchTableList();
        // setIsEdit(false);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  //   useEffect(() => {
  //   fetchTableList();
  // }, []);

  useEffect(() => {
    if (wholeDiscountIdValue) {
      fetchTableList();
    }
  }, [wholeDiscountIdValue]);

  // fetching table data
  const fetchTableList = async (page = 0, pageSize = 10) => {
    try {
      // setLoading(true)
      const response = await axiosInstance.post(
        "/subdiscount/list",
        {
          discount_id: wholeDiscountIdValue,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
      }));

      setDiscountData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
    }
  };

  const fetchProductOptions = async () => {
    try {
      const payload = {
        orderBy: "product_id desc",
        // page: 0,
        // pageSize: 100,
        business_partner_id: formData?.business_partner_id,
      };

      // if (userType === "superadmin") {
      //   payload.business_partner_id = formData.business_partner_id;
      // } else {
      //   payload.business_partner_id = businessPartnerId;
      // }

      const response = await axiosInstance.post(
        "/product/ddlproduct",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchVariantOption = async () => {
    try {
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          business_partner_id: formData?.business_partner_id,
          product_id: formData?.product_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const options = response?.data?.data?.data?.map((variant) => ({
        label: variant?.NAME,
        value: variant?.ID,
      }));

      setVariantDD(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };

  useEffect(() => {
    fetchProductOptions();
  }, []);

  useEffect(() => {
    if (formData.productName && formData.productName) {
      fetchVariantOption();
    }
  }, [formData.productName]);
  useEffect(() => {
    if (formData?.variant_id) {
      const fetchVariantBasedDetails = async () => {
        try {
          const response = await axiosInstance.post(
            "/variant/ddlvariantbasedetails",
            {
              //business_partner_id: 1,
              variant_id: formData.variant_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          const variantwisedata = response?.data?.data?.data[0];
          console.log("variantwisedata", variantwisedata);

          setFormData({
            ...formData,

            fuel: variantwisedata?.fuel_type_name,
            fuel_type_id: variantwisedata?.fuel_type_id,
            subproductName: variantwisedata?.subproduct_name,
            subproduct_id: variantwisedata?.subproduct_id,
            make: variantwisedata?.make_name,
            make_id: variantwisedata?.make_id,
            model: variantwisedata?.model_name,
            model_id: variantwisedata?.model_id,
            exshowroomprice: variantwisedata?.exshowroom_price,
            vehiclecolor: variantwisedata?.color_name,
            color_id: variantwisedata?.color_id,
          });
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };
      fetchVariantBasedDetails();
    }
  }, [formData?.variant_id]);

  useEffect(() => {
    fetchDiscountProduct();
  }, []);

  const fetchDiscountProduct = async () => {
    try {
      const response = await axiosInstance.get(
        `/discount/edit/${data.discount_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const fetchedData = response.data.data;
      console.log("fetchedData", fetchedData);
      // Update formData with fetched data
      setFormData({
        min_quantity: fetchedData.min_quantity,
        discount_name: fetchedData.discount_name,
        status: fetchedData.status === 1 ? true : false,
        duration_months: fetchedData.duration_months,
        discount: fetchedData.discount,
        // discount_type: fetchedData.discount_type,
        discount_fromdate: fetchedData.discount_fromdate,
        discount_todate: fetchedData.discount_todate,
        model_id: fetchedData.model_id,
      });

      const discountFetchedId = fetchedData?.discount_id;
      setWholeDiscountIdValue(discountFetchedId);
      console.log(discountFetchedId, "discountFetchedIdValue");
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log("formdatadiscount", formData);

    const errors = {};
    let isValid = true;

    // Validate the form fields
    VariantInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Showalert({
      title: "Confirmation",
      text: "Are you sure you want to update this discount?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
      callback: async () => {
        try {
          setLoading(true);
          const payload = {
            product_id: formData.productName,
            // subproduct_id: formData.subproduct_id,
            //make_id: formData.make_id,
            model_id: formData.model_id,
            //fuel_type_id: formData.fuel_type_id,
            // variant_id: formData.variant_id,
            //color_id: formData.color_id,
            //exshowroom_price: formData.exshowroomprice.toString(),
            // min_quantity: formData.min_quantity,
            duration_months: formData.duration_months,
            discount_name: formData.discount_name,
            // discount_fromdate: formData.discount_fromdate,
            // discount_todate: formData.discount_todate,
            // discount_type: formData.discount_type,
            //level1_approveal: formData.level1_approveal,
            // level2_approveal: formData.level2_approveal,
            status: formData.status === true ? 1 : 0,
          };

          const response = await axiosInstance.patch(
            `/discount/update/${data.discount_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          console.log("API Response:", response.data);

          // Success alert and navigation
          Showalert({
            title: "Success",
            text: "Discount updated successfully.",
            icon: "success",
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: "OK",
            callback: () => {
              navigate("/admin/manage-product/discount");
            },
          });
        } catch (error) {
          console.error("Error submitting form:", error);

          // Error alert
          Showalert({
            title: "Error",
            text: "There was an issue updating the discount. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              // onClick={() => navigate("/admin/manage-product/discount")}
            >
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Update Discount</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Edit Discount Details
              </span>
              <DynamicForm
                formConfig={VariantInputs}
                formData={formData}
                setFormData={setFormData}
                exshowroomprice={formData?.exshowroomprice}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  }}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div>
              <DynamicForm
                formConfig={DiscountInputs}
                formData={formData}
                setFormData={setFormData}
                exshowroomprice={formData?.exshowroomprice}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />

              <button
                onClick={() => {
                  handleFormSave(formData);
                }}
                className="submit-btn"
              >
                Save
              </button>
            </div>
          </>
        )}
      </div>
      <CustomTable
        data={discountData}
        headers={VARIANT_TABLE_HEADERS}
        keyMapping={variantKeyMapping}
        itemsPerPage={10}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onEdit={handleEdit}
        totalRecords={totalRecords}
        isADDcomplainTable="true"
      />
    </>
  );
};

export default EditDiscount;
